import classNames from 'classnames';

export function SectionWrapper({ className, children }: { className?: string; children: React.ReactNode }) {
  const classes = classNames('flex w-full text-white bg-[#191714] border border-[#352F28] p-5 rounded-md', className);
  return <div className={classes}>{children}</div>;
}
